import React, { Component } from 'react'
import Sidebar from 'react-sidebar'

import {
  Hamburger,
  SideMenu,
  X,
  Links,
  Title,
  StyledLink,
  Dash
} from './styles'

class SideBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sidebarOpen: false
    }
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this)
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open })
  }

  LinkGroup = links =>
    links.map(section => (
      <Links key={section.title}>
        <Title>{section.title}</Title>
        {section.links &&
          section.links.map(link => (
            <StyledLink
              to={link.link}
              key={link.title}
              onClick={() => this.onSetSidebarOpen(false)}
            >
              {link.title}
            </StyledLink>
          ))}
      </Links>
    ))

  render() {
    return (
      <Sidebar
        sidebar={
          <b>
            <SideMenu display={this.state.sidebarOpen ? 'flex' : 'none'}>
              <X onClick={() => this.onSetSidebarOpen(false)}>✖</X>
              {this.props.links.main && this.LinkGroup(this.props.links.main)}
              <Dash />
              {this.props.links.other && this.LinkGroup(this.props.links.other)}
            </SideMenu>
          </b>
        }
        open={this.state.sidebarOpen}
        onSetOpen={this.onSetSidebarOpen}
        styles={{
          sidebar: {
            background: 'transparent',
            backfaceVisibility: 'hidden'
          },
          overlay: { background: 'rgba(30, 30, 70, 0.5)' },
          root: {
            height: 0,
            position: 'unset'
          },
          content: { overflowY: 'scroll', WebkitOverflowScrolling: 'touch' }
        }}
        pullRight
        shadow={false}
      >
        <div>
          {!this.state.sidebarOpen && (
            <Hamburger
              onClick={() => this.onSetSidebarOpen(!this.state.sidebarOpen)}
            >
              ☰
            </Hamburger>
          )}
          {this.props.children}
        </div>
      </Sidebar>
    )
  }
}

export default SideBar



// WEBPACK FOOTER //
// ./src/components/SideBar/index.js